<template>
  <div class="page">
    <van-nav-bar
      left-text="订单详情"
      left-arrow
      right-text="我的地址"
      @click-left="goBack"
      @click-right="viewMyAddress"
    >
    </van-nav-bar>

    <div class="header">
      <span class="title">
        <van-icon size="2.2em" :name="require('@/assets/images/totext.png')" :style="{ verticalAlign: 'middle' }" />
        待填写收货地址
      </span>
      <span class="desc">请您填写收取礼品的地址</span>
    </div>

    <van-form validate-first label-width="4.2em" @submit="onSubmit">
      <van-field
        v-model="name"
        name="name"
        label="收货人"
        placeholder="请填写收货人姓名"
        :rules="[{ required: true, message: '请填写收货人姓名' }]"
      />
      <van-field
        v-model="phone"
        name="phone"
        label="手机号"
        placeholder="请填写收货人手机号"
        :rules="[{ pattern: phonePattern, message: '请填写正确的手机号' }]"
      />
      <van-field
        readonly
        clickable
        name="location"
        :value="location"
        label="所在地区"
        placeholder="省市区县、乡镇等"
        @click="showPicker = true"
        :right-icon="require('@/assets/images/locationimg.png')"
        :rules="[{ required: true, message: '请选择所在地区' }]"
      >
        <template #button>
          <span :style="{ color: '#000' }">定位</span>
        </template>
      </van-field>
      <van-field
        v-model="address"
        name="address"
        label="详细地址"
        placeholder="如道路、门牌号、小区、楼栋号、单元室等"
        :rules="[{ required: true, message: '请填写详细地址' }]"
      />

      <div class="button-container">
        <van-button block color="#ff9326" native-type="submit"> 保存 </van-button>
      </div>
    </van-form>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar value-key="name" :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>

<script>
import cityColumns from '@/assets/js/pcas-code.json'
import { complete } from '@/api/freeTake'

export default {
  data() {
    return {
      name: '',
      phone: '',
      location: '',
      address: '',
      phonePattern: /^1[3|4|5|7|8|9]\d{9}$/,
      showPicker: false,
      columns: cityColumns,
      orderId: this.$route.query.orderId,
      addressCode: null,
    }
  },
  created() {
    this.name = this.$route.query.name
    this.phone = this.$route.query.phone
    this.address = this.$route.query.address
    this.addressCode = this.$route.query.addressCode
    this.location = this.getLocationByAddressCode(this.addressCode)
  },
  methods: {
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },
    viewMyAddress() {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      this.$router.push({
        path: '/mall/myaddress',
        query: {
          ...query,
          from: 'freetake',
        },
      })
    },
    onSubmit(values) {
      let that = this
      console.log('submit', values)
      that.$dialog.confirm({
        message: '保存后不可修改收货地址请核实后点击确定保存',
        beforeClose(action, done) {
          if (action === 'confirm') {
            complete({
              addressCode: that.addressCode,
              contacts: that.name,
              deliveryMethod: 1,
              detailsAddress: that.address,
              orderId: that.orderId,
              phoneNumber: that.phone,
            })
              .then(res => {
                that.$router.push(`/mall/order-detail?id=${that.orderId}`)
              })
              .finally(() => {
                done()
              })
          } else {
            done()
          }
        },
      })
    },
    onConfirm(value, idxs) {
      this.addressCode = this.columns[idxs[0]].children[idxs[1]].children[idxs[2]].children[idxs[3]].code
      this.location = value.join('/')
      this.showPicker = false
    },
    /**
     * 根据AddressCode获取完整的地址名
     */
    getLocationByAddressCode(code) {
      if (!code) {
        return ''
      }
      const one = this.columns.find(item => item.code === code.substr(0, 2))
      const two = one.children.find(item => item.code === code.substr(0, 4))
      const three = two.children.find(item => item.code === code.substr(0, 6))
      const four = three.children.find(item => item.code === code.substr(0, 9))

      return one.name + '/' + two.name + '/' + three.name + '/' + four.name
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background-color: #efefef;

  /deep/ .van-nav-bar .van-icon,
  /deep/ .van-nav-bar__text {
    font-size: 18px !important;
    color: #000;
  }

  /deep/ .van-nav-bar__right .van-nav-bar__text {
    color: #3492ea;
  }

  .header {
    height: 114px;
    text-align: center;

    .title {
      display: block;
      padding-top: 37px;
      font-size: 18px;
      color: #666;
    }

    .desc {
      margin-top: 10px;
      display: block;
      bottom: 15px;
      font-size: 12px;
      color: #9fa0a0;
    }
  }
  .button-container {
    width: 100%;
    position: absolute;
    bottom: 0;
  }
}
</style>
